import React, { useState, useEffect } from 'react';

const MerritoPopup = () => {
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    const handleOpen = () => setIsOpen(true);
    window.addEventListener('open-enquiry-popup', handleOpen);
    return () => window.removeEventListener('open-enquiry-popup', handleOpen);
  }, []);

  return (
    <>
      {/* Floating Button (Bottom Right) */}
      <button 
        onClick={() => setIsOpen(true)}
        className="fixed bottom-5 right-5 md:bottom-8 md:right-8 text-white py-3 px-6 md:py-4 md:px-7 rounded-full font-semibold text-[15px] md:text-[16px] tracking-wide shadow-[0_8px_24px_rgba(27,49,96,0.35)] z-[100] hover:-translate-y-1 hover:shadow-[0_12px_32px_rgba(27,49,96,0.5)] transition-all flex items-center justify-center gap-2"
        style={{ background: 'linear-gradient(135deg, #1b3160 0%, #0d1b33 100%)' }}
      >
        <i className="fas fa-edit text-[14px]"></i>
        <span>Enquiry Now</span>
      </button>

      {/* Popup Overlay */}
      {isOpen && (
        <div 
          className="fixed inset-0 bg-black/70 backdrop-blur-sm z-[9999] flex items-center justify-center p-2 sm:p-4 animate-fadeIn"
          onClick={() => setIsOpen(false)}
        >
          <div 
            className="rounded-2xl shadow-[0_20px_60px_rgba(0,0,0,0.4)] w-full max-w-[500px] bg-white overflow-hidden relative flex flex-col h-[650px] md:h-[480px] max-h-[92vh]"
            style={{ animation: 'slideUp 0.3s ease-out' }}
            onClick={(e) => e.stopPropagation()}
          >
            {/* Modal Header */}
            <div className="px-5 py-2.5 relative text-white flex items-center justify-between shrink-0" style={{ background: 'linear-gradient(135deg, #1b3160 0%, #0d1b33 100%)' }}>
              <div>
                <h2 className="text-[16px] md:text-[18px] font-semibold m-0 tracking-tight text-white leading-tight">Admission Enquiry Form</h2>
                <p className="mt-0.5 text-white/80 text-[11px] leading-tight">Fill in your details below</p>
              </div>
              <button 
                onClick={() => setIsOpen(false)}
                className="w-7 h-7 rounded-full flex items-center justify-center text-[16px] text-white hover:bg-white/20 transition-all focus:outline-none"
                style={{ background: 'rgba(255, 255, 255, 0.15)' }}
                aria-label="Close"
              >
                &times;
              </button>
            </div>
            
            {/* Form Container with NextERP iframe */}
            <div className="w-full bg-white overflow-hidden flex-1 relative enquiry-iframe-wrap">
              <iframe 
                src="https://sawsvasundhara.nexterp.in/nlp/nlp/fill-form?id=1399" 
                title="Admission Enquiry Form"
                frameBorder="0"
                scrolling="no"
                className="w-full h-full border-0 block enquiry-iframe"
                style={{ overflow: 'hidden' }}
              ></iframe>
            </div>
          </div>
        </div>
      )}
      
      <style dangerouslySetInnerHTML={{__html: `
        @keyframes fadeIn { from { opacity: 0; } to { opacity: 1; } }
        @keyframes slideUp { from { transform: translateY(30px); opacity: 0; } to { transform: translateY(0); opacity: 1; } }

        /* Mobile View: Native 100% width & height for authentic 1-column mobile layout with no scroll */
        .enquiry-iframe {
          width: 100% !important;
          height: 100% !important;
          transform: none !important;
        }

        /* Desktop View (md: 768px+): scale slightly to fit all fields within 480px cleanly without scroll */
        @media (min-width: 768px) {
          .enquiry-iframe-wrap {
            --iframe-scale: 0.94;
          }
          .enquiry-iframe {
            width: calc(100% / var(--iframe-scale)) !important;
            height: calc(100% / var(--iframe-scale)) !important;
            transform: scale(var(--iframe-scale)) !important;
            transform-origin: top left !important;
          }
        }
      `}} />
    </>
  );
};

export default MerritoPopup;
